<footer>
    <p>Copyright &copy; 2021 Kevin Mo.</p>
    <p>Images are sourced from the <a href="https://www.loc.gov/collections/prokudin-gorskii/" target="_blank">Prokudin-Gorskii collection</a>.</p>
</footer>

<style>
footer {
    color: #888;
    font-size: 0.8em;
    text-align: center;
    margin-top: 10vh;
    padding: 2em 0;
}
</style>